(function() {
  'use strict';

  angular
    .module('app.customerAccount')
    .controller('ImageUploadController', ImageUploadController);

  ImageUploadController.$inject = [
    '$scope',
    '$uibModalInstance',
    'AccountUpdateService',
    'SessionService',
    'toaster',
    'APP_CONSTANTS',
    '$window',
    '$timeout'
  ];

  /* eslint-disable */
  function ImageUploadController(
    $scope,
    $uibModalInstance,
    AccountUpdateService,
    SessionService,
    toaster,
    APP_CONSTANTS,
    $window,
    $timeout
  ) {
    var vm = this;

    vm.loading = false;
    $scope.flag = false;
    vm.wrongImageFormat = false;

    vm.submit = submit;
    vm.cancel = cancel;

    $scope.validateImage = function(files) {
      var ext = files[0].name.match(/\.(.+)$/)[1];

      if (
        angular.lowercase(ext) === 'jpg' ||
        angular.lowercase(ext) === 'jpeg' ||
        angular.lowercase(ext) === 'png' ||
        angular.lowercase(ext) === 'gif'
      ) {
        vm.wrongImageFormat = false;
        handleFileSelect(files);
      } else {
        $scope.$apply(function() {
          vm.wrongImageFormat = true;
        });

        return;
      }
    };

    function handleFileSelect(files) {
      var file = files[0];
      var reader = new FileReader();

      reader.onload = function(evt) {
        $scope.$apply(function() {
          vm.image = evt.target.result;
          vm.croppedImage = evt.target.result;
        });
      };
      if (file) reader.readAsDataURL(file);
    }

    function saveImage() {
      vm.loading = true;

      var imageData = {};
      var currentUser = SessionService.getUser();

      imageData.base64 = vm.croppedImage;

      AccountUpdateService.uploadImage(imageData, currentUser.customerId).then(
        function(response) {
          vm.loading = false;
          vm.croppedImage = response.data.data;
          AccountUpdateService.setImage(imageData.base64);
          toaster.pop('success', APP_CONSTANTS.MESSAGE.successfullyUpdated);
          $uibModalInstance.close();
        },
        function(error) {
          vm.loading = false;
          if (error.status === 413) {
            toaster.pop('error', APP_CONSTANTS.MESSAGE.imageSizeLarge);
          } else {
            toaster.pop('error', error.data.message || error.statusText);
          }
          vm.croppedImage = AccountUpdateService.getImage();
        }
      );
    }

    function submit(cropUrl) {
      if (vm.wrongImageFormat) return;
      if (cropUrl.substring(0, 10) === 'data:image' && cropUrl.length > 40) {
        vm.wrongImageFormat = false;
        vm.croppedImage = cropUrl;
        saveImage();
      } else {
        vm.wrongImageFormat = true;

        return;
      }
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();
/* eslint-enable */
